import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";

import useRequest from "../../hooks/useRequest";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { Input, SubmitButton, SubTab, SubInput } from "../Form/Form";
import { createSlug } from "../../util/fn";

const Edit = (props) => {
  const { id } = props.match.params;
  // const brandId = window.location.href.split("/")[4];
console.log(id,"id")
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  const history = useHistory();

  const { languages } = useSelector((state) => state.setting);

  const { response, request } = useRequest();
  const { response: responseFetchSeeker, request: requestFetchSeeker } =
    useRequest();

  useEffect(() => {
    if (id) {
      requestFetchSeeker("GET", `master/spares/${id}`);
      document.title = `Edit Spare Side - Easyspare`;
    }
  }, [id]);
  useEffect(() => {
    if (responseFetchSeeker?.master) {
      const spareDetails = responseFetchSeeker.master.langData;
      console.log("spareDetails", spareDetails)

      for (let i = 0; i < spareDetails.length; i++) {
        const code = spareDetails[i].languageCode;
        
        const name = spareDetails[i].name;
        setValue(`name-${code}`, `${name}`);
      }
    }
  }, [responseFetchSeeker]);
  useEffect(() => {
    if (response) {
      toast.success("SpareSide  updated successfully.");
      history.push(`/spare-side`);
    }
  }, [response]);

  const onSubmit = (data) => {
    const dataToSend = [];
    const checkData = {
      label: "",
      value: "",
      langData: [],
    };

    let name;
    let key;

    for (let i = 0; i < languages.length; i++) {
      const code = languages[i].code;

      dataToSend.push({
        languageCode: code,
        name: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });

      if (languages[i].default) {
        name = data["name-" + code];
        checkData.label = name;
        checkData.value = name;
      }

      checkData.langData.push({
        languageCode: code,
        value: data["name-" + code] ?? "",
        slug: data["slug-" + code] ?? "",
      });
    }

    request("PUT", "master/spares", {
      id,
      key:"spare-side",
      name,
      langData: dataToSend,
    });
  };

  return (
    <div className={` d-flex flex-column flex-column-fluid`} id="kt_content">
      <Breadcrumb
        title="Edit Spare Side"
        links={[
          { to: "/", name: "Dashboard" },
          { to:`/spare-side`, name: "Back To SpareSides" },
        ]}
      />

      <div className="d-flex flex-column-fluid">
        <div className=" container ">
          <div className="card card-custom">
            <div class="card-header">
              <h3 class="card-title">Edit Spare Side</h3>
            </div>

            <div className="card-body">
              <div className="row">
                <div className="col-xl-12">
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="card card-custom gutter-b">
                      <div className="card-header card-header-tabs-line">
                        <div className="card-toolbar">
                          <ul
                            className="nav nav-tabs nav-tabs-space-lg nav-tabs-line nav-bold nav-tabs-line-3x"
                            role="tablist"
                          >
                            {languages.length > 0 &&
                              languages.map((lang, index) => (
                                <SubTab
                                  key={index}
                                  name={lang.name}
                                  index={index}
                                  image={lang?.image}
                                  tabName={`language_${index}`}
                                />
                              ))}
                          </ul>
                        </div>
                      </div>

                      <div className="card-body px-0">
                        <div className="tab-content px-10">
                          {languages.length > 0 &&
                            languages.map((lang, index) => (
                              <SubInput
                                key={index}
                                index={index}
                                errors={errors}
                                register={register}
                                required={lang.required}
                                control={control}
                                code={lang.code}
                                tabName={`language_${index}`}
                                InputFields={[
                                  [
                                    {
                                      Component: Input,
                                      label: "Name",
                                      type: "text",
                                      name: "name",
                                      isRequired: true,
                                      colClass: " ",
                                      registerFields: {
                                        onBlur: (e) => {
                                          setValue(
                                            `slug-${lang.code}`,
                                            createSlug(e.target.value)
                                          );
                                        },
                                      },
                                    },
                                  ],
                                ]}
                              />
                            ))}
                        </div>
                      </div>
                    </div>

                    <div className="row"></div>

                    <SubmitButton
                      handleSubmit={handleSubmit}
                      onSubmit={onSubmit}
                      name="Update"
                      pxClass="px-10"
                    />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
